import { render, staticRenderFns } from "./KabKotContent.vue?vue&type=template&id=1c976050&scoped=true"
import script from "./KabKotContent.vue?vue&type=script&lang=js"
export * from "./KabKotContent.vue?vue&type=script&lang=js"
import style0 from "./KabKotContent.vue?vue&type=style&index=0&id=1c976050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c976050",
  null
  
)

export default component.exports